import agentPlatformClient from "./agentPlatformClient";
import { API_ENDPOINTS } from "../commons/ai-chat.constants";

export type ConversationItem = {
  conversationID: string;
  title: string | null;
  lastMessageAt: string | null;
  messageCount: number;
  createdAt: string;
};

export type ConversationListResponse = {
  status: string;
  data: {
    conversations: ConversationItem[];
    nextCursor: string | null;
  };
};

export type ConversationMessageItem = {
  conversationMessageID: string;
  conversationID: string;
  role: "user" | "assistant";
  content: string;
  metadata: Record<string, any> | null;
  createdAt: string;
};

export type ConversationMessagesResponse = {
  status: string;
  data: {
    messages: ConversationMessageItem[];
    nextCursor: string | null;
  };
};

const companyHeaders = (agencyId?: string) => (agencyId ? { "x-company-id": agencyId } : undefined);

export const getConversations = (params: { cursor?: string; limit?: number }, agencyId?: string) =>
  agentPlatformClient.get<ConversationListResponse>(API_ENDPOINTS.LIST_CONVERSATIONS, {
    params,
    headers: companyHeaders(agencyId),
    withCredentials: false,
  });

export const getConversationMessages = (
  conversationID: string,
  params: { cursor?: string; limit?: number },
  agencyId?: string
) =>
  agentPlatformClient.get<ConversationMessagesResponse>(
    API_ENDPOINTS.GET_CONVERSATION_MESSAGES(conversationID),
    { params, headers: companyHeaders(agencyId), withCredentials: false }
  );

export const deleteConversation = (conversationID: string, agencyId?: string) =>
  agentPlatformClient.delete(API_ENDPOINTS.DELETE_CONVERSATION(conversationID), {
    headers: companyHeaders(agencyId),
    withCredentials: false,
  });

export const updateConversationTitle = (conversationID: string, title: string, agencyId?: string) =>
  agentPlatformClient.patch(
    API_ENDPOINTS.UPDATE_CONVERSATION(conversationID),
    { title },
    { headers: companyHeaders(agencyId), withCredentials: false }
  );
